import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';
interface AffiliateMobileCardProps {
  avatar?: ReactNode;
  children: ReactNode;
  aside?: ReactNode;
  footer?: ReactNode;
}

/*
 * On the affiliate dashboard the vendor avatar leads a column of lines — brand, product, customer —
 * and the lines under them keep to that column, which `MobileCardHeader`'s single name and subtitle
 * cannot hold. The grid aligns the footer with the text instead of an indent that has to match the
 * avatar's width; the affiliate page has no avatar, so its grid has no leading column.
 */
export const AffiliateMobileCard = t0 => {
  const $ = _c(13);
  const {
    avatar,
    children,
    aside,
    footer
  } = t0;
  const t1 = avatar ? "grid-cols-[auto_minmax(0,1fr)_auto]" : "grid-cols-[minmax(0,1fr)_auto]";
  let t2;
  if ($[0] !== t1) {
    t2 = twJoin("grid min-w-0 items-start gap-x-3 gap-y-3", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <div className="flex min-w-0 flex-col">{children}</div>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== avatar || $[5] !== footer) {
    t4 = footer && <div className={twJoin("col-span-2 min-w-0", avatar && "col-start-2")}>{footer}</div>;
    $[4] = avatar;
    $[5] = footer;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== aside || $[8] !== avatar || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className={t2}>{avatar}{t3}{aside}{t4}</div>;
    $[7] = aside;
    $[8] = avatar;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};